import {
  NINETAILED_NAME as NAME,
  NINETAILED_DISPLAY_NAME as DISPLAY_NAME,
} from '../../constants/Destinations';

const DIR_NAME = 'Ninetailed';

const CNameMapping = {
  [NAME]: NAME,
  Ninetailed: NAME,
  ninetailed: NAME,
  NineTailed: NAME,
};

export { NAME, CNameMapping, DISPLAY_NAME, DIR_NAME };
